/*
 * Copyright (c) 2025 curryfirm.com
 */

import * as constants from "../../constants.js";

const fetchDumps = async () => {
    const columnMap = {};
    const rowData = [];
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${constants.TRACKER_WORKBOOK_ID}/values/${constants.DUMPS_RANGE}?key=${constants.TRACKER_WORKBOOK_API_KEY}`;
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Error fetching dump locations: ${response.statusText}`);
    }

    const json = await response.json();

    if (!json.values || json.values.length === 0) {
        // Return empty but not null on error.
        return {columnMap, rowData};
    }

    // Construct column index map from row[0]
    const headerRow = json.values[0];
    headerRow.forEach((title, index) => { columnMap[title] = index; });

    return { columnMap: columnMap, rows: json.values.slice(1) };
}

export default fetchDumps;